module.exports = __webpack_public_path__ + "img/Screenshot 2022-12-26 at 3.33.11 PM.88e35696.png";